export enum storeStatus {
  Open = 1,
  Close = 2
}
